import React from 'react';
import './styles.css';
import {
  FiArrowLeft,
} from 'react-icons/fi';

export default function ProcessButton(props) {
  const {
    goBackAction,
    title,
    rightText,
  } = props;

  return (
    <section className="status-container">
      <div>
        <FiArrowLeft className="touchable-icon" size={23} color="#000" onClick={goBackAction} />
      </div>
      {title && <h2 className="title">{title}</h2>}
      {rightText && <h2>{rightText}</h2>}
      <div className="divisory">
        <div className="divisory-line" />
      </div>
    </section>
  );
}
